import { render, staticRenderFns } from "./PaymentMethodLabel.vue?vue&type=template&id=09348a91&scoped=true&"
import script from "./PaymentMethodLabel.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09348a91",
  null
  
)

export default component.exports